import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, tap } from "rxjs";
import { environment } from "../../../environments/environment";
import { AuthToken } from "./auth.model";
import { Offline } from "./offline.model";

@Injectable({ providedIn: "root" })
export class AuthService {
  private readonly httpClient = inject(HttpClient);
  private readonly _token = new BehaviorSubject<AuthToken>(null);
  readonly token$ = this._token.asObservable();
  private readonly _offline = new BehaviorSubject<Offline | undefined>(undefined);
  readonly offline$ = this._offline.asObservable();

  readonly isAuthenticated$ = this.token$.pipe(
    map(token => token !== null)
  );


  get token() {
    return this._token.value;
  }

  private set offline(offline: Offline | undefined) {
    this._offline.next(offline);
  }

  login(): void {
    this.offline = undefined;
    this.httpClient.get<AuthToken>(environment.authTokenUrl).pipe(
      catchError(e => {
        this.offline = { httpError: true };
        throw e;
      }), tap((auth) => {
        if(auth.maintenance) {
          this.offline = { maintenance: true };
        } else {
          this.offline = undefined;
          this._token.next(auth);
        }
      })).subscribe();
  }
}
